import moment from 'moment';
import {
  CodeTableNumber,
  MetadataCodeWithAdditionalPropertiesDictionary
} from '../interfaces';
import { Requirements } from '../interfaces/customer';

const getBirthDateFromAge = (age: number) => {
  if (!age) {
    return null;
  }
  return moment().subtract(age, 'years');
};

/* Requirements for create customer */
export const getCreateSubscriberRequirements = (
  subscriberRequirements: MetadataCodeWithAdditionalPropertiesDictionary<
    | CodeTableNumber.SubscriberRequirements
    | CodeTableNumber.SubscriberCategoryRequirements
  >[]
): Requirements => {
  const requirementsConfig =
    subscriberRequirements.find((config) => !config.Global) ||
    subscriberRequirements.find((config) => config.Global);
  const requirements: Requirements =
    requirementsConfig?.AdditionalProperties || {};
  const resultsMap: Requirements = {};
  if (requirements) {
    Object.keys(requirements).forEach((requirementType: string) => {
      switch (requirementType) {
        case 'maximum_age':
          resultsMap.maximum_age_birthdate = getBirthDateFromAge(
            requirements[requirementType]
          );
          resultsMap[requirementType] = requirements[requirementType];
          break;
        case 'minimum_age':
          resultsMap.maximum_age_birthdate = getBirthDateFromAge(
            requirements[requirementType]
          );
          resultsMap[requirementType] = requirements[requirementType];
          break;
        default:
          resultsMap[requirementType] = requirements[requirementType];
      }
    });
  }
  return resultsMap;
};
